import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Routes } from 'core/domains/settings';
import config from 'config';
import type { RootState } from 'core';

export const useRedirectToHome = () => {
  const history = useHistory();
  const homePage = useSelector(
    (state: RootState) =>
      state.settings.data.routes.find((route: Routes) => route.isHomepage)?.path,
  );
  return {
    redirectToHome: () => {
      history.push(homePage ?? config.app.homepage);
    },
  };
};
